<p>resource-details-base works!</p>
